




































import {Component, Prop, Vue} from "nuxt-property-decorator";

@Component({
  components: {},
})

export default class PagePagination extends Vue {
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  private readonly breadcrumbs!: any[];
  $i18n: any;
  localePath: any;

  linkPath(path: string) {
    let _link = this.$i18n.localeProperties.code == 'ru' && path == '/' ? `/${this.$i18n.localeProperties.code}` : path;
    _link = this.localePath(_link);
    if (_link[_link.length - 1] === '/') {
      _link = _link.slice(0, -1);
    }
    return _link || '/'
  }
}
